import { PointsAccountingException } from '@/domain/points/accounting/exception/PointsAccountingException'

export class TransactionNotFoundException extends PointsAccountingException {

}

